const LANGUAGES = [
  'abap', 'arm', 'bash', 'c', 'cpp', 'csharp', 'clojure', 'cobol', 'css', 'd', 'dart', 'dockerfile', 'elixir', 'erlang', 'fortran',
  'golang', 'haml', 'haskell', 'html', 'java', 'javascript', 'json', 'julia', 'kotlin', 'tex', 'lua', 'markdown', 'matlab', 'nginx',
  'nim', 'nix', 'objectivec', 'pascal', 'perl', 'php', 'powershell', 'python', 'qml', 'r', 'ruby', 'rust', 'scheme', 'scss', 'sql', 'stylus',
  'swift', 'typescript', 'vbscript', 'yaml',
];

export default LANGUAGES;
